import React from "react";
import styles from "./StepProgress.module.less";
import range from "lodash/range";
import classNames from "classnames";
import { defineMessages, injectIntl } from "react-intl";
const messages = defineMessages({
    valueText: {
        id: "registration.stepProgress.valueText",
        defaultMessage: "{percent}% Step {current} of {total}"
    }
});
function StepProgress(props) {
    const current = Math.max(Math.min(props.current, props.total), 0);
    const trackWidth = current === props.total ? 100 : 100 * current / (props.total - 1);
    const percent = Math.round(100 * current / props.total);
    const percentIndex = current === props.total ? props.total - 1 : Math.floor(current);
    const valueText = props.intl.formatMessage(messages.valueText, {
        current: Math.floor(current + 1),
        total: props.total,
        percent
    });
    return (<div className={styles.container} role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} aria-valuetext={valueText}>
			<span className="u-isVisuallyHidden">
				{valueText}
			</span>
			<div className={styles.track} aria-hidden>
				<div style={{ width: `${trackWidth}%` }}/>
			</div>
			<ul className={styles.steps} aria-hidden>
				{range(0, props.total).map(index => (<li key={index} className={classNames({
        [styles.active]: index === current,
        [styles.complete]: index < current
    })}>
						{index === percentIndex && (`${percent}%`)}
					</li>))}
			</ul>
		</div>);
}
export default injectIntl(StepProgress);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/Registration/StepProgress/StepProgress.tsx